import React, { useEffect, useState } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import BankAccountCard from "../../components/BankInfo/BankAccountCard";
import {
  deActivateAccount,
  getAccountList,
  getSdkOtp,
} from "../../api/bankApi/BankAccountList";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../components/Header/Header";
import { isEmpty } from "lodash";
import "./BankInfo.css";
import Loader from "../../components/GeneralComponents";
import edit from "../../assets/images/Edit.png";
import { BackButton } from "../../components/General/BackButton";
import { useNavigate } from "react-router";
import { Modal } from "antd";
import { openWidget } from "aerosync-web-sdk";
import { aeroPayAccountSuccess } from "../../api/bankApi/AddBankAccount";
import { aero_pay_environment, consumer_id, deep_link_base } from "../../constants";
import PhoneInput from "react-phone-input-2";
import { setOtpVerificationModal } from "../../actions/CommonActions.js";
import TwoFaModal from "../../components/2FA/TwoFaModal.js";
import { Axios } from "../../utils/axiosMiddleware";
import Disclaimer from "../../components/BankInfo/Disclaimer.js";

const BankAccountList = (props) => {
  const [loading, setLoading] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [willVerifyUserRegisterNumber, setWillVerifyUserRegisterNumber] =
    useState(false);
  const [willSetNewPhoneNumber, setWillSetNewPhoneNumber] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("+1");
  const [isPhoneNumberError, setIsPhoneNumberError] = useState("");

  const userTypeData = useSelector((state) => state?.common?.fullUser);
  const bankAccountList = useSelector(
    (state) => state?.bankInfo?.bankAccountList
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      if (userTypeData?.id) {
        const list = await getAccountList(userTypeData?.id, dispatch);
        if (list?.length === 0) {
          const token = await getSdkOtp(userTypeData?.id);
          if (token) {
            openAerosyncWidget(token);
          }
        }
      }
      setLoading(false);
    };
    getData();
  }, [userTypeData?.id]);

  const handleEditAccount = async () => {
    setLoading(true);

    const token = await getSdkOtp(userTypeData?.id);

    if (token) {
      openAerosyncWidget(token);
    }
    setLoading(false);
  };

  const openAerosyncWidget = (accessToken) => {
    let token = accessToken;
    let deeplink = deep_link_base; // Universal link back into the app (GIG-25 — replaces retired gigmi.page.link)
    let consumerId = consumer_id; // Unique ID of the consumer

    let widgetRef = openWidget({
      id: "widget",
      iframeTitle: "Connect",
      environment: aero_pay_environment, // staging, production
      token: token,
      style: {
        width: "375px",
        height: "688px",
        bgColor: "#000000",
        opacity: 0.7,
      },
      deeplink: deeplink,
      consumerId,
      onEvent: function () {},
      onLoad: function () {},
      onError: function () {},
      onSuccess: function (event) {
        aeroPayAccountSuccess({
          userId: userTypeData?.id,
          user_id: event.user_id,
          user_password: event.user_password,
        });
      },
      onClose: function () {
        navigate("/");
      },
    });
    widgetRef.launch();
  };

  const confirmAction = async () => {
    setConfirmModal(false);
    setLoading(true);
    const body = {
      bankAccountId: selectedId,
    };
    await deActivateAccount(userTypeData?.id, body);
    setLoading(false);
    navigate("/");
  };

  const willVerifyUserRegisterNumberConfirm = () => {
    const phone = userTypeData?.username?.includes("@")
      ? userTypeData?.phone
      : userTypeData?.username;

    setWillVerifyUserRegisterNumber(false);
    setPhoneNumber(phone?.substring(2));
    setWillSetNewPhoneNumber(true);
  };

  const willSetNewPhoneNumberConfirm = async () => {
    if (phoneNumber && phoneNumber?.length === 11) {
      try {
        setLoading(true);
        setWillSetNewPhoneNumber(false);
        await Axios.patch(`/user/aeroPay/number`, {
          userId: userTypeData?.id,
          phone: "+" + phoneNumber,
        });

        dispatch(
          setOtpVerificationModal({
            visible: true,
            phone: "+" + phoneNumber,
            username: userTypeData?.username,
            otp: "",
          })
        );

        setLoading(false);
      } catch (error) {
        if (
          error?.response?.data?.message ==
          "This phone is already in use. Please try with new one."
        ) {
          window.alert(
            "This phone is already in use. Please try with new one."
          );
        }
        setWillSetNewPhoneNumber(true);
        setLoading(false);
      }
    } else {
      setIsPhoneNumberError(true);
    }
  };

  const handleVerifyOtp = async (otp, message) => {
    setLoading(true);
    try {
      await Axios.post(`user/aeroPay/account`, {
        userId: userTypeData?.id,
        otp,
        phone: "+" + phoneNumber,
      });
      dispatch(setOtpVerificationModal({ visible: false, phone: "", otp: "" }));
      handleEditAccount();
    } catch (e) {
      const error =
        e?.response?.data?.message ||
        (e?.response?.data?.[0] && JSON.stringify(e?.response?.data?.[0])) ||
        "No response from Banking Partner, Please try again later.";

      if (
        error.includes(
          "You've previously used AeroPay to pay another business. Please verify your identity by entering the pin sent to your email"
        )
      ) {
        dispatch(
          setOtpVerificationModal({
            visible: true,
            message: e.response?.data?.message || error,
            phone: "",
            otp: "",
          })
        );
      } else if (
        e?.response?.data?.message ==
        "This phone is already in use. Please try with new one."
      ) {
        window.alert("This phone is already in use. Please try with new one.");
      }
      setLoading(false);
    }
    setLoading(false);
  };

  return (
    <>
      <div id="widget"></div>
      {loading && (
        <div className="search-loader">
          <Loader />
        </div>
      )}
      <BackButton />
      <div className="container paymentscreen">
        <Header />
        <div className="paymentscreen-inner">
          <div className="d-flex">
            <div className="banklist-heading d-flex justify-content-end">
              <FormattedMessage id="bank_accounts" />
            </div>
            <div className="add-button d-flex justify-content-end mr-1 cursor-pointer">
              <img
                src={edit}
                onClick={() => {
                  if (userTypeData?.aeroPayPhoneNumber) {
                    handleEditAccount();
                  } else {
                    setWillVerifyUserRegisterNumber(true);
                    setPhoneNumber("+1");
                  }
                }}
              />
            </div>
          </div>
          {!isEmpty(bankAccountList) &&
            bankAccountList.map((item) => {
              return (
                <BankAccountCard
                  key={item?.id}
                  item={item}
                  setConfirmModal={setConfirmModal}
                  setSelectedId={setSelectedId}
                />
              );
            })}
        </div>
      </div>
      <Modal
        open={confirmModal}
        onCancel={() => setConfirmModal(false)}
        footer={null}
        style={{ height: "800px" }}
      >
        <div>
          <div className="disclaimer1 text-center mt-3">
            <FormattedMessage id="confirm_default" />
          </div>
          <div className="d-flex justify-content-center mt-5">
            <button
              style={{
                backgroundColor: "#F77E0B",
                color: "white",
                fontSize: "17px",
                fontFamily: "Poppins",
                border: "none",
                borderRadius: "3px",
                zIndex: 1000,
              }}
              onClick={confirmAction}
            >
              <FormattedMessage id="make_default" />
            </button>
          </div>
        </div>
      </Modal>
      <Disclaimer
        showModal={willVerifyUserRegisterNumber}
        setShowModal={() => setWillVerifyUserRegisterNumber(false)}
        title={<FormattedMessage id="phone_number_verification" />}
        body={<FormattedMessage id="phone_number_verification_description" />}
        confirmText={<FormattedMessage id="yes" />}
        cancelText={<FormattedMessage id="no" />}
        handleClick={willVerifyUserRegisterNumberConfirm}
        handleCancel={() => {
          setWillVerifyUserRegisterNumber(false);
          setWillSetNewPhoneNumber(true);
        }}
      />
      <Disclaimer
        showModal={willSetNewPhoneNumber}
        setShowModal={() => setWillSetNewPhoneNumber(false)}
        title={<FormattedMessage id="phone_number_verification" />}
        body={
          <>
            <PhoneInput
              inputProps={{
                name: "phone",
                required: true,
              }}
              value={phoneNumber}
              onChange={(text) => {
                setPhoneNumber(text);
                setIsPhoneNumberError(false);
              }}
              onlyCountries={["us"]}
              countryCodeEditable={false}
              inputStyle={{
                width: "100%",
                height: "56px",
                backgroundColor: "#E6E7EB",
                marginTop: "8px",
              }}
              country={"us"}
              className="w-100 phonenumber_field countries"
              inputClass="contact_field"
            />
            {isPhoneNumberError && (
              <span style={{ color: "red", cursor: "pointer", fontSize: 12 }}>
                <FormattedMessage id="phone_number_required" />
              </span>
            )}
          </>
        }
        confirmText={<FormattedMessage id="confirm" />}
        cancelText={<FormattedMessage id="cancel" />}
        handleClick={willSetNewPhoneNumberConfirm}
        handleCancel={() => {
          setWillSetNewPhoneNumber(false);
        }}
      />
      <TwoFaModal handleVerifyOtp={handleVerifyOtp} loading={loading} />
    </>
  );
};
export default injectIntl(BankAccountList);
